"use strict";
// import { METHODS } from 'http';
// import { SignatureKeyErrorsType, IUSDWindowFunctions } from './interfaces';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./interfaces"), exports);
__exportStar(require("./manager"), exports);
// export abstract class USD<DATA, METHODS> implements Omit<IUSDWindowFunctions<DATA & METHODS>, 'setAgentClientData'> {
//   protected methods?: METHODS;
//   protected data?: DATA;
//   protected interface: IUSDWindowFunctions<DATA & METHODS>;
//   constructor(inter: IUSDWindowFunctions<DATA & METHODS>) {
//     this.interface = inter;
//   }
//   abstract parseMethods: (data: DATA & METHODS) => METHODS;
//   abstract parseData: (data: DATA & METHODS) => DATA;
//   init = async (): Promise<void> => {
//     window.setAgentClientData = (data: DATA & METHODS) => {
//       this.methods = this.parseMethods(data);
//       this.data = this.parseData(data);
//       this.interface.setAgentClientData(data);
//     };
//   };
//   getData = (): DATA => {
//     if (!this.data) {
//       throw new Error('should call init before getData');
//     }
//     return this.data;
//   };
//   getMethods = (): METHODS => {
//     if (!this.methods) {
//       throw new Error('should call init before getMethods');
//     }
//     return this.methods;
//   };
//   refreshAgentToken = (agentToken: string): void => {
//     this.interface.refreshAgentToken(agentToken);
//   };
//   invalidateSessionTokens = (): void => {
//     this.interface.invalidateSessionTokens();
//   };
//   refreshSessionTokens = (accessToken: string, refreshToken: string): void => {
//     this.interface.refreshSessionTokens(accessToken, refreshToken);
//   };
//   notifyInteractionEnded = (): void => {
//     this.interface.notifyInteractionEnded();
//   };
//   RaiseN2InIvrSuccess = (): void => {
//     this.interface.RaiseN2InIvrSuccess();
//   };
//   RaiseN2InIvrFailure = (error: SignatureKeyErrorsType): void => {
//     this.interface.RaiseN2InIvrFailure(error);
//   };
//   updateSignatureKeySuccess = (): void => {
//     this.interface.updateSignatureKeySuccess();
//   };
//   updateSignatureKeyFailure = (error: SignatureKeyErrorsType): void => {
//     this.interface.updateSignatureKeyFailure(error);
//   };
//   createPasswordOnboardingFinished = (ivrCode: string): void => {
//     this.interface.createPasswordOnboardingFinished(ivrCode);
//   };
// }
//# sourceMappingURL=index.js.map